import { setLabels } from "../helpers/enum-helpers";

export enum Unit {
    Each = 1,
    Pallet = 2
}

setLabels<Unit>(Unit, [
    [ Unit.Each, 'Pieces' ],
    [ Unit.Pallet, 'Pallets' ],
]);
